import { render, staticRenderFns } from "./BackgroundProcessProgress.vue?vue&type=template&id=87b2ed7e&scoped=true"
import script from "./BackgroundProcessProgress.vue?vue&type=script&lang=js"
export * from "./BackgroundProcessProgress.vue?vue&type=script&lang=js"
import style0 from "./BackgroundProcessProgress.vue?vue&type=style&index=0&id=87b2ed7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b2ed7e",
  null
  
)

export default component.exports